import { Component, inject, OnInit, DestroyRef , ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '@core/services/auth.service';
import { SignalRService } from '@core/services/signalr.service';
import { HeaderComponent } from './layout/header/header.component';
import { TourOverlayComponent } from '@shared/components/tour-overlay/tour-overlay.component';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, HeaderComponent, TourOverlayComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private authService = inject(AuthService);
  private signalRService = inject(SignalRService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  title = 'qa-agent-ui';
  showHeader = true;

  constructor() {
    // Hide header on login page
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe((event: any) => {
        this.showHeader = !event.url.includes('/login');
      });
  }

  async ngOnInit(): Promise<void> {
    console.log('🚀 App component initialized (MSAL already ready via APP_INITIALIZER)');

    // Initialize SignalR connection if user is authenticated
    this.authService.currentUser$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user: any) => {
        if (user) {
          this.initializeSignalR();
        } else {
          this.disconnectSignalR();
        }
      });
  }

  /**
   * Initialize SignalR connection
   */
  private async initializeSignalR(): Promise<void> {
    try {
      await this.signalRService.connect();
      console.log('SignalR initialized successfully');
    } catch (error) {
      console.error('Failed to initialize SignalR:', error);
    }
  }

  /**
   * Disconnect SignalR connection
   */
  private async disconnectSignalR(): Promise<void> {
    try {
      await this.signalRService.disconnect();
      console.log('SignalR disconnected successfully');
    } catch (error) {
      console.error('Failed to disconnect SignalR:', error);
    }
  }
}
